/**
  * Converts camelCase and snake_case to lowercase space-separated words.
 *
 * Example:
 *  serviceTeaser -> "service teaser"
 *  accordion_item -> "accordion item"
 */
export function formatPageBlockTrackingContentType(string: string): string {
  return string
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .toLowerCase();
}
